<template>
  <div>
        <div class="divisao">
            <button :class="{btnBorda:true,'btnRed':atualBtn == 1 }" style="width:120px;height:37px;height:45px;font-size: 18px;"  @click="btnRed= true,mudarPara(1)">NCMs</button>
            <button :class="{btnBorda:true,'btnRed':atualBtn != 1}"  style="width:120px;height:37px;height:45px;font-size: 18px;margin-left: 20px;" @click="btnRed= false;mudarPara(2)">Exceções</button>
        </div>
        <div class="opFiltrar">
           <span> Filtrar: </span> 
          <div class="dropdown">
            <button class="dropbtn">{{nome}}</button>
            <span class="triangulo"></span>
            <div class="dropdown-content" style="left:0;">
                <a href="#" @click="changeNcms(2,'Alíquota Zero')">Alíquota Zero</a>
                <a href="#" @click="changeNcms(1,'Monofásica')">Monofásica</a>
                <a href="#" @click="changeNcms(3,'Substituição Tributária')">Substituição Tributária</a>
            </div>
            </div>
        </div>
        <div class="ncms-excecoes">
          <div v-for="n in dados" :key="n">
            <span>{{n.ncm}}</span> -  <span style="font-size: 14px;" v-html="n.descricao"></span>
            <div  v-if="n.observacao" style="font-size: 12px;
    padding: 3px;
    background: rgb(255, 170, 33);
    border-radius: 0px 0px 5px 5px;
    color: rgb(0, 0, 0);
    font-weight: bold;
    border: none;
    margin-left: -12px;
    margin-right: -12px;
    margin-top: 6px;
    margin-bottom: -12px;
    border-bottom-left-radius: 0px;">
              {{n.observacao}}
            </div>
          </div>
        </div>
        <div class="pagi" style="display:flex;justify-content: center;margin-top:50px;">         
        </div>
  </div>
</template>

<script>

import axios from 'axios' 
export default {

    data(){
        return{
          nome:'Alíquota Zero',
          dados:[],
          atual:1,
          atualBtn:1,
          currentPage:1,
          perPage:2,       
          op:[
                {"nome":"Aliquota",array:[]},
                {"nome":"Mono",array:[]},
                {"nome":"Aliquota",array:[]},
            ]            
        }
    },
    methods:{
      mudarPara(i){
        this.atualBtn = i
        if(i == 1){
            this.dados = this.op[this.atual-1].array[0][0].ncms.lista
        }else{
           this.dados = this.op[this.atual-1].array[0][1].excecoes.lista
        }
      },
      async changeNcms(atual,nome){
        this.atual = atual
        this.nome = nome
        if(this.op[atual-1].array.length == 0){
        await axios.get(`https://www.lefisc.com.br/api/revisor/${atual}`)
            .then(result=>{
            this.op[atual-1].array.push(result.data)
             this.dados = this.op[atual-1].array[0][0].ncms.lista
              console.log(this.dados)
              this.mudarPara(this.atualBtn)
            })
            .catch(_=>console.log(_))
        }else{
             this.dados = this.op[atual-1].array[0][0].ncms.lista
            console.log(this.dados)
             this.mudarPara(this.atualBtn)
        }
      }
    },    
    async created(){
      
      await this.changeNcms(2,'Alíquota Zero')
     
    }
}
</script>

<style>
.btnRed{
  background:#AF3437 !important ;
  color: #fff !important;
}
.ncms-excecoes div{
  background: #FFFFFF;
    border: 1px solid #AF3437;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 12px;
    margin-top: 20px;
    border-left: 8px solid#AF3437;
    color:#393842
}
.ncms-excecoes div span:nth-child(1){
  font-weight: bold;
}
.ncms-excecoes  div:hover{
  background: #dcdcdcad;
}
.triangulo{
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #AF3437;
  position: absolute;  
  right: 9px;
  top: 9px;
}

.btnBorda{ 
    margin-top: 30px;
    background: #fff;
    border: none;
    border: 1px solid;
    border-radius: 5px;
    color: #AF3437;
    font-weight: bold;
}
.opFiltrar{
    font-weight: bold;
    margin-top: 50px;
    margin-bottom: 42px;
}
.opFiltrar span{
    color: #AF3437;
}
.dropbtn {
 background-color: #fff;      
    font-size: 15px;   
    cursor: pointer; 
    border: 1px solid #AF3437;
    box-sizing: border-box;
    border-radius: 5px;
    color: #AF3437;
    box-sizing: border-box;  
    height: 26px;
    width: 280px;
    font-weight: bold;
}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  font-weight: 600;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}
.dropdown-content a {
  color: #AF3437;
  padding: 7px 7px;
  text-decoration: none;
  display: block;
 
  
}
.dropdown:hover .dropdown-content {display: block;}

</style>